// @flow

import * as React from 'react';
import { localize, unescaped } from '@ta/common.i18n';

import styles from './ReasonForCrust.less';

type Props = {
  /** the feed section */
  section?: ?any,
};

function getReasonText(section) {
  if (section) {
    if (section.reasonFor === 'PREVIOUS_VIEWED' && section.reasonForLocation) {
      /** Because you viewed poiName */
      return unescaped(
        localize('rebrand_recommended_POI_list_shelf_title_with_placename', {
          poiName: `<a href="${section.reasonForLocation.url}" class="ui_link">${
            section.reasonForLocation.name
          }</a>`,
        }),
      );
    }
  }
  return null;
}

const ReasonForCrust = ({ section }: Props) => {
  const reasonText = getReasonText(section);

  if (!reasonText) {
    return null;
  }

  return <div className={styles.reason}>{reasonText}</div>;
};

ReasonForCrust.defaultProps = {
  section: null,
};

export default ReasonForCrust;
